import { EReadyBusinessType, IOfferSchema } from 'shared/types/api-models/offer-card/v1/get-offer-data';
import { capitalize } from 'shared/utils/capitalize';

export const READY_BUSINESS_TITLE = 'Готовый бизнес';
export const RENTAL_BUSINESS_TITLE = 'Арендный бизнес';

export function getNewBusinessTitle(offer: IOfferSchema): string {
  if (
    offer.readyBusinessType === EReadyBusinessType.Other ||
    offer.readyBusinessType === EReadyBusinessType.ReadyBusiness
  ) {
    const [specialty] = offer.specialty?.specialties || [];

    return [READY_BUSINESS_TITLE, specialty?.rusName && capitalize(specialty.rusName)].filter(Boolean).join(' ⋅ ');
  }

  return RENTAL_BUSINESS_TITLE;
}
